import React from 'react'
import Chaptersection from './Chaptersection'


export default function Chapterwithnavfooter() {
  return (

    <Chaptersection />

  )
}
